export default {
    modules: {
        chat: true,
        inbox: true,
        medical: true,
        symptom: true,
        healthtips: true,
        profile: true,
        documents: false,
        emergency: false,
        share: true
    },
    practitioner: {
        type: 'doctor',
        plural_type: 'doctors',
    },
    app: {
        name: 'Free Doctor',
        endpoint: 'https://medi4u.co.za/freedoctor/'
    },
    registration: {
        simple: true,
        free: true
    },
    location: false,
    share: {
        message: 'For free medical advice, download this great app: https://www.freedoctor.co.za/app/link',
        title: "Free Doctor Chat 24/7"
    }
}